// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2NNHY","title":"ClientInsurance_title__2rOh8","itemText":"ClientInsurance_itemText__2ro-a"};